import { authModule } from '@/store'

/**
 * Fetches the user if we have an access token, but don't enforce authentication.
 *
 * This is used for pages that are accessible for both authenticated and guest users.
 */
export default async function () {
  if (authModule.loggedIn && !authModule.isLoaded) {
    await authModule.fetchUser()
  }
}
